<template>
  <app-loading-sheet />
</template>

<script>
import RoutesMixin from '@/mixins/RoutesMixin';
import { NAMESPACE } from '@/modules/Authentication/store';
import {
  ADMIN_TOKEN_KEY_IMPERSONATE,
  AUTH_TOKEN_KEY_DEFAULT,
  AUTH_TOKEN_KEY_IMPERSONATE,
  REFRESH_TOKEN_KEY_DEFAULT,
  REFRESH_TOKEN_KEY_IMPERSONATE
} from '@/plugins/vue-auth';
import RouteName from '@/statics/routeName';
import { mapActions } from 'vuex';

export default {
  name: 'ImpersonateView',

  mixins: [RoutesMixin],

  methods: {
    ...mapActions(NAMESPACE, ['impersonateUser'])
  },

  async created() {
    this.$auth.token(AUTH_TOKEN_KEY_DEFAULT, null);
    this.$auth.token(REFRESH_TOKEN_KEY_DEFAULT, null);
    this.$auth.token(AUTH_TOKEN_KEY_IMPERSONATE, null);
    this.$auth.token(REFRESH_TOKEN_KEY_IMPERSONATE, null);
    this.$auth.token(ADMIN_TOKEN_KEY_IMPERSONATE, null);

    const { data, error } = await this.impersonateUser(this.$route.params.hash);

    if (error) {
      await this.$router.push({ name: RouteName.LOGIN });
      return;
    }

    sessionStorage.setItem(AUTH_TOKEN_KEY_IMPERSONATE, data.token);
    sessionStorage.setItem(REFRESH_TOKEN_KEY_IMPERSONATE, data.refreshToken);
    sessionStorage.setItem(ADMIN_TOKEN_KEY_IMPERSONATE, data.adminToken);

    await this.$auth.fetch();
    await this.$router.push(this.$route.query.redirect || { name: this.defaultRoute.route });
  }
};
</script>
